import { LinkContainer } from 'react-router-bootstrap';
import { useHistory } from 'react-router-dom';

import { useAccount } from '../Context/AccountProvider';
import { handleLogout } from '../services/AuthService';
import { LoginForm } from './LoginForm';
import { SidebarWidget } from './SidebarWidget/SidebarWidget';

function SidebarAccount() {
    const { accountInfo, setAccInfo } = useAccount();
    const history = useHistory();

    function logout() {
        setAccInfo({ loggedIn: false });
        handleLogout();
        history.push('/');
    }

    if (accountInfo.loggedIn && accountInfo.user) {
        return (
            <SidebarWidget title="My Account">
                <div className="sw-account">
                    <img
                        className="sw-account-avatar"
                        src={`/images/avatar/${accountInfo.user.avatar}.webp`}
                        alt="User Avatar"
                    />
                    <div className="sw-account-info">
                        <span className="sw-account-name">
                            Welcome, {accountInfo.user.name}
                        </span>
                        <div className="sw-account-actions">
                            <LinkContainer activeClassName="" to="/myaccount">
                                <span
                                    className="sw-account-link"
                                    onClick={() => document.getElementById('main-content').scrollIntoView(true)}
                                >
                                    Dashboard
                                </span>
                            </LinkContainer>
                            <span className="sw-account-link sw-account-link--logout" onClick={logout}>Logout</span>
                        </div>
                    </div>
                </div>
            </SidebarWidget>
        );
    }

    if (accountInfo.loggedIn && accountInfo.user === undefined) {
        return (
            <SidebarWidget title="My Account">
                <p className="sw-account-notice">
                    Welcome! Create an in-game character to view your account.
                </p>
            </SidebarWidget>
        );
    }

    return (
        <SidebarWidget title="Login">
            <div className="sw-login-form">
                <LoginForm register />
            </div>
        </SidebarWidget>
    );
}

export default SidebarAccount;
